"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PXWidgetConfig_1 = require("../../../Extendables/PXWidgetConfig");
const configs_1 = require("../../../configs/configs");
class SelectorWidgetConfig extends PXWidgetConfig_1.default {
    static getDefaults() {
        return Object.assign(super.getDefaults(), {
            saveProgressEnabled: configs_1.configs.widgetConfigDefaults.saveProgressEnabled,
            clone: configs_1.configs.widgetConfigDefaults.clone,
            sourceDealerId: configs_1.configs.widgetConfigDefaults.source,
            sourceUrl: window.location.href
        });
    }
    getCustomer() {
        return this.customer;
    }
    setCustomer(customer) {
        this.customer = customer;
        return this;
    }
    isSaveProgressEnabled() {
        return this.saveProgressEnabled;
    }
    isCloneValuationEnabled() {
        return this.clone;
    }
    getSourceUrl() {
        return this.sourceUrl;
    }
    setSourceUrl(sourceUrl) {
        this.sourceUrl = sourceUrl;
        return this;
    }
    getSourceDealerId() {
        return this.sourceDealerId;
    }
    setSourceDealerId(sourceDealerId) {
        this.sourceDealerId = sourceDealerId;
        return this;
    }
    static getValueMapping() {
        const mapping = super.getValueMapping();
        mapping.value = Object.assign(Object.assign({}, mapping.value), { customer: {
                type: "object",
                getter: true,
                required: false
            }, saveProgressEnabled: {
                type: "boolean",
                getter: "isSaveProgressEnabled",
                required: true
            }, clone: {
                type: "boolean",
                getter: "isCloneValuationEnabled",
                required: true
            }, sourceDealerId: {
                type: "string",
                getter: true,
                regex: /^(?!\s*$).+/,
                required: true
            }, sourceUrl: {
                type: "string",
                getter: true
            } });
        return mapping;
    }
}
exports.default = SelectorWidgetConfig;
